import { ORDER_DATA_TAB_MESSAGES, OrderDataTabMessages } from "./order-data-tab.messages";
import { ORDER_REQUEST_MESSAGES, OrderRequestMessages } from "./order-request-messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import {
  PAYMENT_METHOD_MESSAGES,
  PaymentMethodMessages,
} from "../paymentMethods/payment-method.messages";

export type PaymentDataTabMessages = ActionButtonMessages &
  OrderRequestMessages &
  PaymentMethodMessages &
  OrderDataTabMessages & {
    // Group Titles
    groupOrderValueTitle: string;
    groupPaymentsTitle: string;

    // Field Labels
    orderFreightLabel: string;
    giftPackingPriceLabel: string;
    orderDiscountLabel: string;
    orderChargesLabel: string;
    orderComments1Label: string;
    orderAmountLabel: string;
    paymentTotalAmountLabel: string;
    differenceAmountLabel: string;

    // Table Columns
    paymentDateColumn: string;
    paymentMethodColumn: string;
    paymentAmountColumn: string;
    optionsColumn: string;

    //Error messages
    paymentAmountRequired: string;
    paymentAmountMoreThanZero: string;
    invalidPaymentValue: string;
    paymentMismatchError: string;
    charactersRemaining: string;
    characterLimitExceeded: string;
    noPaymentsMessage: string;
    paymentAmountMinValue: string;

    //Buttons messages
    addNewMethod: string;
    removeMethod: string;
  };

export const PAYMENT_DATA_TAB_MESSAGES: PaymentDataTabMessages = {
  // Group Titles
  groupOrderValueTitle: "Valores do Pedido",
  groupPaymentsTitle: "Pagamentos",

  // Field Labels
  orderFreightLabel: "Frete",
  giftPackingPriceLabel: "Preço da Embalagem de Presente",
  orderDiscountLabel: "Desconto",
  orderChargesLabel: "Encargos",
  orderComments1Label: "Observação",
  orderAmountLabel: "Valor do Pedido",
  paymentTotalAmountLabel: "Valor Pago",
  differenceAmountLabel: "Valor a Receber",

  // Table Columns
  paymentDateColumn: "Data de Pagamento",
  paymentMethodColumn: "Método de Pagamento",
  paymentAmountColumn: "Valor",
  optionsColumn: "Opções",

  //Error messages
  paymentAmountRequired: "O valor do pagamento é obrigatório.",
  paymentAmountMoreThanZero: "O valor do pagamento deve ser maior que zero.",
  invalidPaymentValue: "O valor total do pagamento não corresponde ao valor esperado do pedido.",
  paymentMismatchError: "O valor pago deve ser igual ao valor do pedido",
  charactersRemaining: "caracteres restantes",
  characterLimitExceeded: "O limite de caracteres foi excedido",
  //Buttons messages
  addNewMethod: "Novo pagamento",
  removeMethod: "Excluir",

  noPaymentsMessage: "Nenhum pagamento foi adicionado.",
  paymentAmountMinValue: "O valor deve ser maior ou igual a 1.",

  ...ORDER_DATA_TAB_MESSAGES,
  ...PAYMENT_METHOD_MESSAGES,
  ...ORDER_REQUEST_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
